module.exports = __webpack_public_path__ + "static/media/bottom_infographic_mobile.1c2bc435.webp";